export class DeliverySelect {
  isActive = false;
  deliveryMethod: string = '';
  deliveryDuration: string = '';
  deliveryPrice: string = '';

  constructor(isActive: boolean, deliveryMethod: string, deliveryDuration: string, deliveryPrice: string) {
    this.isActive = isActive;
    this.deliveryMethod = deliveryMethod;
    this.deliveryDuration = deliveryDuration;
    this.deliveryPrice = deliveryPrice;
  }
}
